import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import { SymbolLookup, LastUpdated } from '@cube/finance-blocks';
import style from './style';
import StockList from '../stock-list';
import Container from '../container';

export default class StocksWidget extends Component {

	handleSymbolSelect = (quote) => {
		window.location = `/finance/category/stockdetail/symbol/${quote.UniqueSymbol}`;
	};

	static defaultProps = {
		query: {
			type: 'STOCK',
			list: '+dollarVolume',
			filter: 'MAJORCOMPANIES',
			limit: 8
		},
		columns: [
			'symbol',
			'price',
			'changeCompound',
			'dollarVolume'
		],
		title: <Text id="MOST_ACTIVE_STOCKS" />
	};

	render({ query, columns, title, titleIcon, theme }) {
		return (
			<Container transform="uppercase" title={title} titleIcon={titleIcon} theme={theme}>
				<StockList
					showHeaders
					query={query}
					columns={columns}
					trackingSource="stocks-widget"
					theme={theme}
				/>
				<SymbolLookup
					class={style.symbolLookup}
					onSymbolSelect={this.handleSymbolSelect}
					trackingSource="stocks-widget/symbol-lookup"
					trackingZone="finance-components"
					theme={theme}
				/>
				<LastUpdated theme={theme} />
			</Container>
		);
	}
}
